module.exports = __webpack_public_path__ + "img/linux.82c32e3a.png";